import { useState } from "react"
import { TextField } from "@mui/material"
import PropTypes from "prop-types"
import { validateCustomViewName } from "./helpers"

export default function MetricsSelectorHeader({ customViewName, setCustomViewName, setCanSaveView }) {
  const [errors, setErrors] = useState({})

  function handleChange(event) {
    const name = event.target.value
    setCustomViewName(name)
    const isNameEmpty = name === ""
    const isValidName = isNameEmpty || validateCustomViewName(name)
    setCanSaveView(!isNameEmpty && isValidName)
    setErrors({ name: !isValidName })
  }

  return <div className="metrics-selector-header">
    <TextField
      className="custom-view-name-input"
      variant="standard"
      size="small"
      label="View Name"
      value={customViewName}
      onChange={handleChange}
      margin="normal"
      helperText={errors.name ? "Invalid name. Please follow naming guidelines." : "3-50 chars long. Alphanum, _, -, and spaces."}
      slotProps={{
          formHelperText: { error: errors.name, classes: { root: "topic-name-error" } },
      }}
    />
  </div>
}

MetricsSelectorHeader.propTypes = {
  customViewName: PropTypes.string.isRequired,
  setCustomViewName: PropTypes.func.isRequired,
  setCanSaveView: PropTypes.func.isRequired,
}
